(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var subscriptionRadios = document.querySelectorAll('input[type="radio"][name="subscription"]');
    var sellingPlanElement = document.querySelector('[data-selling-plan]');
    var frequencyElement = document.querySelector('.frequency');
    sellingPlanElement.value = frequencyElement.querySelector(':checked').value;
    function handleSubscriptionChange(event) {
      var selectedValue = event.target.value;
      console.log('Selected subscription value:', selectedValue);
      if (selectedValue == 'onetimepurchase') {
        sellingPlanElement.setAttribute('name', 'fake_selling_plan');
        sellingPlanElement.setAttribute('disabled', true);
      } else {
        sellingPlanElement.setAttribute('name', 'selling_plan');
        sellingPlanElement.removeAttribute('disabled');
      }

      var targetProductOptionsBox = event.target.closest('.product-options-box');
      var allProductOptionsBoxes = document.querySelectorAll('.product-options-box');

      allProductOptionsBoxes.forEach(function (productOptionsBox) {
        if (productOptionsBox === targetProductOptionsBox) {
          productOptionsBox.classList.add('selected');
          productOptionsBox.classList.add('no-border');
        } else {
          productOptionsBox.classList.remove('selected');
          productOptionsBox.classList.remove('no-border');
        }
      });

      window.bundlePrice = window.bundlePrice || 0;
      let planPrice = event.target.dataset.price;
      let atc_price = document.querySelector('.btn__price').textContent;
      var numericValue = parseFloat(atc_price.replace(/[^\d.]/g, ''));
      var result = parseFloat(planPrice) + parseFloat(window.bundlePrice);
      document.querySelector('.btn__price').innerHTML = themeVendor.themeCurrency.formatMoney(result, theme.moneyFormat);
    }

    subscriptionRadios.forEach(function (radio) {
      radio.addEventListener('change', handleSubscriptionChange);
    });

    frequencyElement.addEventListener('change', (e) => {
      sellingPlanElement.value = frequencyElement.querySelector(':checked').value;
    });
    const targetNode = document.querySelector('body');

    const config = { childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE && node.matches('.rc-container-wrapper')) {
              document.querySelector('.rc-container-wrapper').remove();
            }
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
  });
})();
